import { render, staticRenderFns } from "./mobilize.vue?vue&type=template&id=967393e2&scoped=true&"
import script from "./mobilize.vue?vue&type=script&lang=js&"
export * from "./mobilize.vue?vue&type=script&lang=js&"
import style0 from "./mobilize.vue?vue&type=style&index=0&id=967393e2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "967393e2",
  null
  
)

export default component.exports